import { View } from "binder"
import { TemplateSelectorEditorViewModel } from "src/formBuilder/formBuilder/templateEditor/propertiesPanel/editors/templateSelectorEditor/templateSelectorEditor-viewModel";
import { ShowPopupViewModel } from "./showPopup-viewModel"

export class ShowPopupView extends View<ShowPopupViewModel>{
    GetViewUniqueId(): string {
        return "V-FE5AD86D-7DCD-442D-AAFC-74C0F5E67C51"
    }
    loadHtml(): string {
        let element = require('./showPopup.html').default;
        let style = require('./showPopup.less');
        return element;
    }
    constructor() {
       super();
    }

    public set VariableName(v: string) { this._VariableName = v; } public get VariableName(): string { return this._VariableName;} private _VariableName: string;
    public set templateSelector(v: TemplateSelectorEditorViewModel) { this._templateSelector = v; } public get templateSelector(): TemplateSelectorEditorViewModel { return this._templateSelector;} private _templateSelector: TemplateSelectorEditorViewModel;
    public set popupWidth(v: string) { this._popupWidth = v; } public get popupWidth(): string { return this._popupWidth;} private _popupWidth: string;
    public set popupHeight(v: string) { this._popupHeight = v; } public get popupHeight(): string { return this._popupHeight;} private _popupHeight: string;
    public set waitUntilFinish(v: boolean) { this._waitUntilFinish = v; } public get waitUntilFinish(): boolean { return this._waitUntilFinish;} private _waitUntilFinish: boolean;
    public set returnVariableName(v: string) { this._returnVariableName = v; } public get returnVariableName(): string { return this._returnVariableName;} private _returnVariableName: string;

}
